import InvestmentsAPI from './InvestmentsAPI';
export default InvestmentsAPI;
